// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  gtag: {
    ascent: 'G-11111111',
    avanti: 'G-22222222'
  },
  /**
   * When the UI is not served from the same origin as Cake (e.g. `ng serve` on :4200, API on :80),
   * set this to the API base with no trailing slash (e.g. `http://localhost` or `http://127.0.0.1:8080`).
   * Used for `/files/...` previews and the Media Library iframe so they hit the backend.
   * Leave empty for production or Docker where Angular and API share one origin.
   */
  publicAssetsOrigin: '' as string
};
